import { z } from 'zod';
import { loanIdSchema, methodSchema, requestIdSchema, smsIdSchema, apiResponseType, providerType, } from '@repo/shared/types';
import { internalErrorResponseSchema, loanDataNotFoundResponseSchema, loanResponseBaseSchema, } from './loan-shared.schema';
export var loanSignVerifyRequestBodySchema = z.object({
    requestId: requestIdSchema,
    loanId: loanIdSchema,
    smsId: smsIdSchema.nullable(),
    provider: providerType,
    smsCode: z.string().length(7).nullable(),
    method: methodSchema,
});
// Response code 200
export var loanSignVerifySuccessResponseBodySchema = loanResponseBaseSchema.and(z.object({
    data: z.object({
        loanId: loanIdSchema,
        signed: z.boolean(),
        method: methodSchema,
        smsId: smsIdSchema.optional(),
    }),
}));
// Response code 400 is limited only to the type field for the pragma provider
export var loanSignVerifyBadRequestResponseBodySchema = z.object({
    type: apiResponseType,
});
// Response code 404
export var loanSignVerifyNotFoundResponseBodySchema = loanDataNotFoundResponseSchema;
// Response code 500
export var loanSignVerifyInternalErrorResponseBodySchema = internalErrorResponseSchema;
